import { getPageURLFromBrowser, getPageReferer } from '../commonAttributes';
import { pushEvent } from '../dataLayer';
import { EVENT_TYPES } from '../../constants/eventTypes';
import CustomConfig from '../../configuration/customConfig';
import { GlobalStorage } from '../../utils/global';
import { CustomEventData } from '../../constants/customEventDataModel';

/**
 * This function is used to create the custom event.
 * @param customEventData the information about the custom event
 */
export function trackCustomEvent(customEventData: CustomEventData) {
  pushEvent({
    eventType: EVENT_TYPES.CUSTOM,
    eventContentType: customEventData.event.type,
    pageURL: getPageURLFromBrowser(),
    eventName: customEventData.event.name,
    eventTimestamp: Date.now(),
    pageReferer: getPageReferer(),
    description: customEventData.event.description,
    customData: customEventData.data,
  });
}
